import busyCall from "@/src/assets/images/neutral/call/busy_call.svg";
import goingCall from "@/src/assets/images/neutral/call/going_call.svg";
import forwardCall from "@/src/assets/images/neutral/call/forward_call.svg";
import voicemailCall from "@/src/assets/images/dark/call/voicemail_call.svg";
import transferCall from "@/src/assets/images/dark/call/transfer_call.svg";
import cancelledCall from "@/src/assets/images/neutral/call/cancelled_call.svg";
import powerDialerGrey from "@/src/assets/images/neutral/call/power_dialer.svg";
import parallelDialerGrey from "@/src/assets/images/neutral/call/parallel_dialer.svg";
import dialerSelectedIcon from "@/src/assets/images/dark/call/selected/dialer.svg";
import dialerSelectedLightIcon from "@/src/assets/images/light/call/selected/dialer.svg";
import dialerUnselectedIcon from "@/src/assets/images/dark/call/unselected/dialer.svg";
import dialerUnselectedLightIcon from "@/src/assets/images/light/call/unselected/dialer.svg";
import dialerNoteSelectedIcon from "@/src/assets/images/dark/call/selected/dialer_note.svg";
import dialerNoteSelectedLightIcon from "@/src/assets/images/light/call/selected/dialer_note.svg";
import dialerNoteUnselectedIcon from "@/src/assets/images/dark/call/unselected/dialer_note.svg";
import dialerNoteUnselectedLightIcon from "@/src/assets/images/light/call/unselected/dialer_note.svg";
import muteSelectedIcon from "@/src/assets/images/dark/call/selected/mute.svg";
import muteSelectedLightIcon from "@/src/assets/images/light/call/selected/mute.svg";
import muteUnselectedIcon from "@/src/assets/images/dark/call/unselected/mute.svg";
import muteUnselectedLightIcon from "@/src/assets/images/light/call/unselected/mute.svg";
import recordSelectedIcon from "@/src/assets/images/dark/call/selected/record.svg";
import recordSelectedLightIcon from "@/src/assets/images/light/call/selected/record.svg";
import recordUnselectedIcon from "@/src/assets/images/dark/call/unselected/record.svg";
import recordUnselectedLightIcon from "@/src/assets/images/light/call/unselected/record.svg";
import transferSelectedIcon from "@/src/assets/images/dark/call/selected/transfer.svg";
import transferSelectedLightIcon from "@/src/assets/images/light/call/selected/transfer.svg";
import transferUnselectedIcon from "@/src/assets/images/dark/call/unselected/transfer.svg";
import transferUnselectedLightIcon from "@/src/assets/images/light/call/unselected/transfer.svg";
import voicemailDropSelectedIcon from "@/src/assets/images/dark/call/selected/voicemail_drop.svg";
import voicemailDropSelectedLightIcon from "@/src/assets/images/light/call/selected/voicemail_drop.svg";
import voicemailDropUnselectedIcon from "@/src/assets/images/dark/call/unselected/voicemail_drop.svg";
import voicemailDropUnselectedLightIcon from "@/src/assets/images/light/call/unselected/voicemail_drop.svg";
import callSwapIcon from "@/src/assets/images/dark/call/swap_call.svg";
import callSwapLightIcon from "@/src/assets/images/light/call/swap_call.svg";
import phoneNumbersSelectedIcon from "@/src/assets/images/dark/selected/phone_numbers.svg";
import phoneNumbersSelectedLightIcon from "@/src/assets/images/light/selected/phone_numbers.svg";
import phoneNumbersUnselectedIcon from "@/src/assets/images/neutral/unselected/phone_numbers.svg";
import dialerSettingsSelectedIcon from "@/src/assets/images/dark/selected/dialer_settings.svg";
import dialerSettingsSelectedLightIcon from "@/src/assets/images/light/selected/dialer_settings.svg";
import dialerSettingsUnselectedIcon from "@/src/assets/images/neutral/unselected/dialer_settings.svg";
import callRoutingSelectedIcon from "@/src/assets/images/dark/selected/call_routing.svg";
import callRoutingSelectedLightIcon from "@/src/assets/images/light/selected/call_routing.svg";
import callRoutingUnselectedIcon from "@/src/assets/images/neutral/unselected/call_routing.svg";
import callDispositionSelectedIcon from "@/src/assets/images/dark/call/call_disposition_selected.svg";
import callDispositionSelectedLightIcon from "@/src/assets/images/light/call/call_disposition_selected.svg";
import callDispositionUnselectedIcon from "@/src/assets/images/dark/call/call_disposition_unselected.svg";
import callDispositionUnselectedLightIcon from "@/src/assets/images/light/call/call_disposition_unselected.svg";
import recordIcon from "@/src/assets/images/neutral/call/record_icon.svg";
import recordingIcon from "@/src/assets/images/neutral/call/recording_icon.svg";
import stopRecordingIconGrey from "@/src/assets/images/neutral/grey/stop_recording_icon.svg";
import transcriptIconGrey from "@/src/assets/images/neutral/grey/transcript_icon.svg";
import inProgressGreenTag from "@/src/assets/images/neutral/call/in_progress_green_tag.svg";
import inProgressPurpleTag from "@/src/assets/images/neutral/call/in_progress_purple_tag.svg";
import voiceAgentPlay from "@/src/assets/images/dark/call/voice_agent_play.svg";
import dialLightIcon from "@/src/assets/images/light/call/dial_icon.svg";
import whatToTalkLightIcon from "@/src/assets/images/light/call/what_to_talk.svg";
import whatToTalk from "@/src/assets/images/dark/call/what_to_talk.svg";
import businessPhoneSelectedIcon from "@/src/assets/images/dark/sidebar/selected/business_phone.svg";
import businessPhoneSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/business_phone.svg";
import businessPhoneUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/business_phone.svg";
import businessPhoneUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/business_phone.svg";
import salesDialerSelectedIcon from "@/src/assets/images/dark/sidebar/selected/sales_dialer.svg";
import salesDialerSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/sales_dialer.svg";
import salesDialerUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/sales_dialer.svg";
import salesDialerUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/sales_dialer.svg";

export default {
  whatToTalkLightIcon,
  busyCall,
  goingCall,
  forwardCall,
  voicemailCall,
  transferCall,
  cancelledCall,
  powerDialerGrey,
  parallelDialerGrey,
  dialerSelectedIcon,
  dialerSelectedLightIcon,
  dialerUnselectedIcon,
  dialerUnselectedLightIcon,
  dialerNoteSelectedIcon,
  dialerNoteSelectedLightIcon,
  dialerNoteUnselectedIcon,
  dialerNoteUnselectedLightIcon,
  muteSelectedIcon,
  muteSelectedLightIcon,
  muteUnselectedIcon,
  muteUnselectedLightIcon,
  recordSelectedIcon,
  recordSelectedLightIcon,
  recordUnselectedIcon,
  recordUnselectedLightIcon,
  transferSelectedIcon,
  transferSelectedLightIcon,
  transferUnselectedIcon,
  transferUnselectedLightIcon,
  voicemailDropSelectedIcon,
  voicemailDropSelectedLightIcon,
  voicemailDropUnselectedIcon,
  voicemailDropUnselectedLightIcon,
  callSwapIcon,
  callSwapLightIcon,
  phoneNumbersSelectedIcon,
  phoneNumbersSelectedLightIcon,
  phoneNumbersUnselectedIcon,
  dialerSettingsSelectedIcon,
  dialerSettingsSelectedLightIcon,
  dialerSettingsUnselectedIcon,
  callRoutingSelectedIcon,
  callRoutingSelectedLightIcon,
  callRoutingUnselectedIcon,
  callDispositionSelectedIcon,
  callDispositionSelectedLightIcon,
  callDispositionUnselectedIcon,
  callDispositionUnselectedLightIcon,
  recordIcon,
  recordingIcon,
  stopRecordingIconGrey,
  transcriptIconGrey,
  inProgressGreenTag,
  inProgressPurpleTag,
  voiceAgentPlay,
  whatToTalk,
  dialLightIcon,
  businessPhoneSelectedIcon,
  businessPhoneSelectedLightIcon,
  businessPhoneUnselectedIcon,
  businessPhoneUnselectedLightIcon,
  salesDialerSelectedIcon,
  salesDialerSelectedLightIcon,
  salesDialerUnselectedIcon,
  salesDialerUnselectedLightIcon,
};
